import { Form } from 'react-bootstrap'
import InputMask from 'react-input-mask'

export function CustomInputMask(props) {
  return (
    <InputMask {...props}>
      {(inputProps) => <Form.Control {...inputProps} />}
    </InputMask>
  )
}
